import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';

export async function getProductInfoForDownload(type: string, warehouse?: string) {
	try {
		const token = cookies?.get(TOKEN_COOKIE_NAME);
		const headers = token ? { Authorization: `Bearer ${token}` } : {};
		const { data } = await axios.get(`${process.env.HOST}/api_v1/products-info/`, {
			params: { type, warehouse },
			headers,
			responseType: 'blob',
		});
		return data;
	} catch (error) {
		console.error(error);
		throw error?.response?.data ?? error?.message ?? 'Ошибка при получении файла выгрузки.';
	}
}
